const CURSOR_LIMIT_REACHED_ERROR = 'cursor-limit-reached';

export const isCursorLimitReachedError = (err) => {
  return !!err && !!err.errors && err.errors.length > 0 && err.errors[0].msg === CURSOR_LIMIT_REACHED_ERROR;
};
